import { Typography, Stack, Chip } from "@mui/material";
import { Education } from "./EducationSection";
import SchoolIcon from '@mui/icons-material/School';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import useIsMobile from "../AppHelpers";

export interface EducationCardProps{
    education:Education
}

const EducationCard = (education:EducationCardProps)=> {
    const isMobile = useIsMobile()
    const getIcon = (type:string)=>{
        return type.toLowerCase()==='continuousdev'? <LocalLibraryIcon color="primary" fontSize='large'></LocalLibraryIcon> : <SchoolIcon color="primary" fontSize='large'></SchoolIcon>
    }
    
    return (
        <Stack direction={'column'} sx={{backgroundColor:"antiqueWhite", textAlign:'left', padding:'2rem', width:'100%', marginTop:'2rem'}}>
            <Stack direction={'row'} >
                {getIcon(education.education.type)} 
                <Stack direction={'column'} sx={{marginLeft:'0.5rem'}}>
                    <Typography variant='h5' color="#420A02" >{education.education.qualificationName} {education.education.subject}</Typography>
                    {!isMobile && <Typography variant="body2" color="#420A02" fontFamily={'Helvetica Neue'} >{education.education.description}</Typography>}
                </Stack>        
                <Chip label={education.education.status} color="primary" variant={education.education.status === 'Qualified' ? 'filled': 'outlined'}  sx={{marginRight:0, marginLeft:'auto'}}></Chip>
            </Stack>
        </Stack>
    );
  }
  
  export default EducationCard;